import { createFileRoute } from "@tanstack/react-router";
import { TransmissaoDetalhePage } from "@/pages/TransmissaoDetalhePage";

export const Route = createFileRoute("/transmissoes/$id")({
  head: () => ({ meta: [{ title: "Transmissão — AXIS Comprovantes" }] }),
  component: TransmissaoDetalhePage,
});
